import React from "react";
import LegalLayout from "./LegalLayout";

const openPreferences = () => {
  window.dispatchEvent(new CustomEvent("leovera:open-cookie-preferences"));
};

const CookiePolicy = () => (
  <LegalLayout
    testid="page-cookie-policy"
    eyebrow="Documento legale"
    title="Cookie Policy"
    updated="Febbraio 2026"
  >
    <p>
      La presente Cookie Policy descrive le tipologie di cookie e tecnologie simili utilizzate dal
      sito <strong>LEOVERA Nutrition</strong> e le finalità del loro impiego. Il documento è
      redatto in conformità al Provvedimento del Garante Privacy del 10 giugno 2021 e al
      Regolamento (UE) 2016/679 (GDPR).
    </p>

    <h2>1. Cosa sono i cookie</h2>
    <p>
      I cookie sono piccoli file di testo che i siti visitati inviano al terminale dell'utente,
      dove vengono memorizzati per essere ritrasmessi agli stessi siti in occasione delle visite
      successive. Possono essere di prima parte (impostati direttamente dal sito) o di terza parte
      (impostati da domini differenti).
    </p>

    <h2>2. Categorie di cookie utilizzati</h2>

    <h3>2.1 Cookie tecnici (necessari)</h3>
    <p>
      Indispensabili al funzionamento del sito. Consentono la navigazione, l'autenticazione,
      la gestione del carrello, la sicurezza e la memorizzazione delle preferenze essenziali.
      La loro installazione <strong>non richiede consenso</strong> ai sensi dell'art. 122 del
      Codice Privacy.
    </p>
    <ul>
      <li><code>leovera_user_token</code> — token di autenticazione JWT dell'area cliente.</li>
      <li><code>leovera_cookie_consent_v1</code> — memorizza la tua scelta sui cookie.</li>
      <li><code>leovera_cart</code> — persistenza degli articoli nel carrello.</li>
    </ul>

    <h3>2.2 Cookie di analisi</h3>
    <p>
      Utilizzati per raccogliere informazioni, in forma aggregata e anonima, sull'utilizzo del
      sito (pagine visitate, tempo di permanenza, dispositivi). Vengono installati
      <strong> solo previo consenso</strong>.
    </p>

    <h3>2.3 Cookie marketing</h3>
    <p>
      Permettono di erogare messaggi pubblicitari personalizzati e misurare l'efficacia delle
      campagne. Possono essere impostati da noi o da partner terzi (es. reti pubblicitarie e
      social network). Vengono installati <strong>solo previo consenso</strong>.
    </p>

    <h2>3. Gestione delle preferenze</h2>
    <p>
      Puoi accettare, rifiutare o personalizzare i cookie in qualsiasi momento tramite il pannello
      dedicato:
    </p>
    <p>
      <button
        type="button"
        data-testid="cookie-policy-reopen"
        onClick={openPreferences}
        className="inline-flex items-center gap-2 border border-[#C0C0C0]/40 text-[#E5E4E2] px-4 py-2 rounded-sm text-[11px] tracking-[0.28em] uppercase hover:bg-[#C0C0C0]/10"
      >
        Riapri preferenze cookie
      </button>
    </p>
    <p>
      In alternativa puoi gestire o bloccare i cookie direttamente dalle impostazioni del tuo
      browser. La disattivazione dei cookie tecnici potrebbe compromettere il corretto
      funzionamento del sito.
    </p>

    <h2>4. Durata dei cookie</h2>
    <ul>
      <li><strong>Cookie di sessione</strong>: eliminati alla chiusura del browser.</li>
      <li><strong>Cookie persistenti</strong>: durata massima 12 mesi, salvo diversa indicazione.</li>
    </ul>

    <h2>5. Titolare e contatti</h2>
    <p>
      Titolare del trattamento è <strong>LEOVERA Nutrition di Davide Allibrio</strong>. Per informazioni scrivi a
      <strong> info@leoveranutrition.it</strong>. Consulta anche la nostra{" "}
      <a href="/privacy">Privacy Policy</a>.
    </p>
  </LegalLayout>
);

export default CookiePolicy;
